import React from 'react';
import type { GatsbyBrowser, GatsbySSR } from 'gatsby';
import '@quantum/ui-atoms/main.css';
import '@quantum/ui-molecules/main.css';
import '@quantum/ui-organisms/main.css';
import '../styles/stylesGlobal.scss';

export const Root: GatsbyBrowser['wrapRootElement'] = ({ element }): JSX.Element => <>{element}</>;

export const RootSSR: GatsbySSR['wrapRootElement'] = ({ element }): JSX.Element => <>{element}</>;
